/**
 * Async function that fetches product JSON from Shopify. Uses the {@link https://shopify.dev/api/ajax/reference/product AJAX Endpoint}
 *
 * @param {String} product_handle - the unique handle to request
 * @return {JSON} product
 */
const getProductByHandle = async product_handle => {
	let response = await fetch(`/products/${product_handle}.js`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});
	let product = await response.json();
	return product;
};

/**
 *  Finds and returns the Shopify product handle from the current URL.
 *  Hard coded to work on product pages, this **will not work** unless URL path contains /products/
 * @return {String} product_handle
 */
const getHandleFromHREF = () => {
	let href = window.location.href;
	return href.includes('?') ? href.split(/products\/(.*?)\?/)[1] : href.split(/products\//).pop();
};

/**
 * Returns a standardized version of a Shopify Product Type for easier comparison logic.
 *
 *
 * @param {String} productType
 * @return {('BASE_FRAME' | 'TOP_FRAME' | 'LENS' | 'ACCESSORY')} normalizedType
 */
const normalizeProductType = productType => {
	return productType.includes('TOP_FRAME') ? 'TOP_FRAME' : productType;
};

const getCollectionByHandle = async handle => {
	let response = await fetch(`/collections/${handle}/products.json`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});
	let collection = await response.json();

	return collection.products;
};

const getOneRecommendedProduct = async (productId, variantTitle, itemGroup) => {
	return fetch(`/recommendations/products.json?product_id=${productId}&limit=10`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then(response => response.json())
		.then(data => {
			const recommendedTopFrames = data.products.filter(p => p.type.includes('TOP_FRAME'));

			for (let i = 0; i < recommendedTopFrames.length; i++) {
				const top = recommendedTopFrames[i];
				if (!itemGroup.some(item => item.product_id === top.id) && variantTitle) {
					const variant = top.variants.find(element => element.title === variantTitle);

					if (variant.available) return variant;
				}
				if (i === recommendedTopFrames.length - 1) {
					return false;
				}
			}
			return recommendedTopFrames[0];
		});
};

const getFirstProductVariantByHandle = async (productHandle, variantTitle) => {
	return await fetch(`/products/${productHandle}.js`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then(response => response.json())
		.then(data => {
			if (variantTitle) {
				return data.variants.find(element => element.title === variantTitle);
			}

			try {
				return data.variants[0];
			} catch (error) {
				console.error(error);
				return false;
			}
		});
};

export {
	getProductByHandle,
	getCollectionByHandle,
	getHandleFromHREF,
	normalizeProductType,
	getOneRecommendedProduct,
	getFirstProductVariantByHandle,
};
